// BEGIN CHANGE: New service for handling presigned uploads
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { Store } from '@ngrx/store';
import { UserState } from '../store/user/user.model';
import { AppLauncherInfo } from '../store/appLauncher/appLauncher.model';

@Injectable({ providedIn: 'root' })
export class PresignUploadService {
  constructor(
    private http: HttpClient,
    private store: Store<{ user: UserState, appLauncher: AppLauncherInfo }>
  ) {}

  async requestPresignedForFile(filename: string, mime: string, folder?: string): Promise<{ url: string; fields?: any }> {
    // Request a presigned URL from the backend
    // Adjust the endpoint path as needed for your API
    const endpoint = `${environment.integrations.bulkUpload}/presign`; 
    const body = { filename, contentType: mime, folder };

    // Mimic websocket.service.ts logic for headers
    const accessToken = await firstValueFrom(this.store.select(state => state.user.userInfo?.accessToken));
    const userEmail = await firstValueFrom(this.store.select(state => state.user.userInfo?.email));
    const apiKey = await firstValueFrom(this.store.select(state => state.appLauncher?.api_key));
    const apiUser = await firstValueFrom(this.store.select(state => state.appLauncher?.user));

    let headers = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Accept', 'application/json');

    if (apiKey) {
      headers = headers.append('X-Api-User', apiUser || '');
      headers = headers.append('X-Api-Key', apiKey);
    } else {
      headers = headers.append('Authorization', `Bearer ${accessToken}`);
      headers = headers.append('X-Api-User', userEmail || '');
    }
    
    return await firstValueFrom(
      this.http.post<{ url: string; fields?: any }>(endpoint, body, { headers })
    );
  }

  async uploadFileToS3Put(url: string, file: File, onProgress?: (pct: number) => void): Promise<void> {
    const resp$ = this.http.put(url, file, {
      reportProgress: true,
      observe: 'events'
    });

    return new Promise((resolve, reject) => {
      resp$.subscribe({
        next: (ev: HttpEvent<any>) => {
          if (ev.type === HttpEventType.UploadProgress && onProgress) {
            const pct = ev.total ? Math.round((ev.loaded / ev.total) * 100) : 0;
            onProgress(pct);
          } else if (ev.type === HttpEventType.Response) {
            resolve();
          }
        },
        error: err => reject(err)
      });
    });
  }
}
// END CHANGE